export default (tree) => {
  let categories = []
  tree.forEach((item) => {
    if (item.children.length === 0) {
      categories.push(item)
    } else {
      categories = this(item.children)
    }
  })
  return categories
}
